/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ImagingDiagnosisDtoImagingProcedure =
  (typeof ImagingDiagnosisDtoImagingProcedure)[keyof typeof ImagingDiagnosisDtoImagingProcedure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImagingDiagnosisDtoImagingProcedure = {
  XRAY: 'XRAY',
  CT_SCAN: 'CT_SCAN',
  MRI: 'MRI',
} as const;
